import { render, staticRenderFns } from "./synchronizeExercises.vue?vue&type=template&id=58b20090&scoped=true"
import script from "./synchronizeExercises.vue?vue&type=script&lang=js"
export * from "./synchronizeExercises.vue?vue&type=script&lang=js"
import style0 from "./synchronizeExercises.vue?vue&type=style&index=0&id=58b20090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b20090",
  null
  
)

export default component.exports